import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MainPagetitle from '../../layouts/MainPagetitle';
import CamperService from '../../api/services/CamperService';
import AdminDatesService from '../../api/services/AdminDatesService';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
import Select from "react-select";
const AddMinimumRent = () => {
  const navigate = useNavigate();
  const [camper, setCamper] = useState([]);
  const [error, setError] = useState([]);
  const [isLoading, setisloading] = useState(true);
  const [selectedCamperType, setSelectedCamperType] = useState(null);
  const [selectedCamperTypeId, setSelectedCamperTypeId] = useState('');
  const getCamper = async () => {
    try {
      let camper = await CamperService.index().json();
      console.log('responsedata : ',camper);
        
      var responsedata = camper.data.filter(function (item) { 
        return item.camper_type_id == 1 && item.status == 1
      });
      setCamper(responsedata);
      setisloading(false);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (localStorage.getItem("admintoken")) {
      getCamper();
    }
    else {
      navigate('/')
    }
  }, []);


  const onSubmitForm = async (event) => {
    event.preventDefault();
    try {
      var userData = {
        "start_date": event.target.start_date.value,
        "end_date": event.target.end_date.value,
        "camper_ids": selectedCamperTypeId ? selectedCamperTypeId : [],
        "minimum_rent_duration": event.target.minimum_rent_duration.value,
        "english_message": event.target.english_message.value,
        "german_message": event.target.german_message.value
      }
      var startDate = new Date(userData.start_date);
      var endDate = new Date(userData.end_date);
      if (startDate > endDate) {
        setError("The Start Date cannot be later than the End Date.");
        return; // Exit the function if the dates are not valid
      }
      else {
        let responseData = await AdminDatesService.store(userData).json()
        if (responseData.status === false) {
          setError(responseData.message);
          return; 
        }
        if (responseData.status === true) {
          navigate("/admin/minimumrentduration-list");
        }
        setError(responseData.errors)
      }
    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }

  };
  const handleSelectCamperType = (selectedOption) => {
    var selectedCamperType;
    if (selectedOption.some(option => option.value === 'select-all-vehicles')) {
      selectedCamperType = camper.map(option => option.id);
      setSelectedCamperType([{ value: 'select-all-vehicles', label: 'Select All Vehicles' }]);
      setSelectedCamperTypeId(selectedCamperType);
    } else {

      selectedCamperType = selectedOption.map(option => option.value);
      setSelectedCamperType(selectedOption);
      setSelectedCamperTypeId(selectedCamperType);
    }
  }
  return (
    <>
      <MainPagetitle mainTitle="Add Minimum Rent Duration" pageTitle={'Add Minimum Rent Duration'} parentTitle={'Home'} />
      <div className="container-fluid">
        <form className="form-valide" onSubmit={onSubmitForm}>
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Add Minimum Rent Duration</h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >StartDate<span className="text-danger">*</span></label>
                      <input type="date" className="form-control" name='start_date' id="val-username"
                      />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >EndDate<span className="text-danger">*</span></label>
                      <input type="date" className="form-control" name='end_date' id="val-username"
                      />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="exampleFormControlInput2" className="form-label"> Select Camper <span className="text-danger">*</span></label>
                      <Select
                        name="camper_ids"
                        value={selectedCamperType}
                        placeholder="Select Vehicles"
                        options={[
                          { value: 'select-all-vehicles', label: 'Select All Vehicles' }, // Add 
                          ...(camper?.map(attr => ({
                            value: attr.id,
                            label: attr.title,
                          })) || []),
                        ]}
                        isMulti
                        onChange={(selectedOption) => handleSelectCamperType(selectedOption)}
                        className={`select2-selection`} />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Minimum Rent Duration<span className="text-danger">*</span></label>
                      <input type="number" className="form-control" name='minimum_rent_duration' id="val-minimum_rent_duration" defaultValue={2}
                      min={2}
                      />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >English Message<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='english_message' id="val-english_message"
                      />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >German Message<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='german_message' id="val-german_message"
                      />
                    </div>
                  </div>
                  <h5 style={{ color: 'red' }}>{error}</h5>
                  <div>
                    <button type="submit" className="btn btn-primary me-1">Submit</button>
                  </div>
                 
                </div>
              </div>
            </div>
          </div>

        </form>
      </div>
      {isLoading && <LogoAnimationLoader />}
    </>
  );
};
export default AddMinimumRent;